import styled from "styled-components";
import { type SpinnerProps } from "./spinner";
import { getBorderColor, getMargin, getSize } from "./spinner.styles.utils";
import { deepMerge } from "../utils/helper";

type WrapperProps = Pick<SpinnerProps, "color" | "size" | "center" | "space">;

export const Wrapper = styled("div")<WrapperProps>(({ color, size, center, space, theme }) => ({
    borderStyle: "solid",
    borderWidth: theme.borderWidth[2],
    borderRadius: theme.borderRadius.full,
    maxWidth: "100%",
    maxHeight: "100%",
    animation: theme.animation.spin,
    animationDuration: "1s",
    ...deepMerge(getSize(size, theme), getBorderColor(color, theme), getMargin(space, theme)),
    ...(center && { marginLeft: "auto", marginRight: "auto" }),
}));
